import { render, staticRenderFns } from "./nameMix.vue?vue&type=template&id=4e43fa08&scoped=true"
import script from "./nameMix.vue?vue&type=script&lang=js"
export * from "./nameMix.vue?vue&type=script&lang=js"
import style0 from "./nameMix.vue?vue&type=style&index=0&id=4e43fa08&prod&lang=scss&scoped=true"
import style1 from "./nameMix.vue?vue&type=style&index=1&id=4e43fa08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43fa08",
  null
  
)

export default component.exports